import React from "react";
import { Colors } from '@capcenter/shared';
import ScrollArea from 'react-scrollbar';
import Location from './Location';
import LocationInt from './Location.interface'

const Locations: React.FC<{locations: Array<LocationInt>}> = (props) => {

  return (
    <>
      <div className="d-none d-lg-block">
      	<ScrollArea style={{paddingLeft: 20, paddingRight:20, backgroundColor: Colors.white100}} verticalScrollbarStyle={{borderRadius: 4}}>

    	  	{props.locations.map((item: LocationInt, i:number)=>
    		  	<Location {...item} last={props.locations.length -1 === i} key={i}/>
    		  )}

      	</ScrollArea>
      </div>
      <div className="d-block d-lg-none">

    	  	{props.locations.map((item: LocationInt, i:number)=>
    		  	<Location {...item} last={props.locations.length -1 === i} key={i}/>
    		  )}

      </div>
    </>
  );
}

export default Locations;
